import { GalleryThumbnailProps } from "@/components/Gallery/components/GalleryThumbnail/GalleryThumbnailProps.ts";

export const GalleryThumbnail = (props: GalleryThumbnailProps) => {
  const { selected, imgSrc, onClick } = props;

  return (
    <div className={"c-gallery-thumbnail".concat(selected ? " c-gallery-thumbnail--selected" : "")}>
      <button onClick={onClick} className="c-gallery-thumbnail__button u-ratio u-ratio--16-9" type="button">
        <figure className="u-ratio__inner">
          <img className="c-gallery-thumbnail__image" src={imgSrc} alt=">SWEN" />
        </figure>
      </button>
    </div>
  );
};
